function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.25 1.5C5.95312 1.5 6.5 2.04688 6.5 2.75V4H11.5V2.75C11.5 2.04688 12.0469 1.5 12.75 1.5C13.4531 1.5 14 2.04688 14 2.75V4H15.25C16.6172 4 17.75 5.13281 17.75 6.5V17.75C17.75 19.1172 16.6172 20.25 15.25 20.25H2.75C1.38281 20.25 0.25 19.1172 0.25 17.75V6.5C0.25 5.13281 1.38281 4 2.75 4H4V2.75C4 2.04688 4.54688 1.5 5.25 1.5ZM5.25 11.5C4.54688 11.5 4 12.0469 4 12.75V15.25C4 15.9531 4.54688 16.5 5.25 16.5H12.75C13.4531 16.5 14 15.9531 14 15.25V12.75C14 12.0469 13.4531 11.5 12.75 11.5H5.25Z",
  fill: "#006CA3"
});

function SvgCalendarReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarReport);
export default __webpack_public_path__ + "static/media/calendar-report.c904fdca.svg";
export { ForwardRef as ReactComponent };